import type {ComponentProps, FC} from 'react';

import NiceModal from '@ebay/nice-modal-react';
import {injectable} from 'inversify';

@injectable()
export class ModalService {
  register<T extends FC<any>>(id: string, comp: T) {
    NiceModal.register(id, comp);
  }

  show<C extends FC>(id: string, props: ComponentProps<C>) {
    NiceModal.show(id, props);
  }
}
